'use client'

import { map, size } from 'lodash-es'
import CommentRow from './row'

export default function CommentList({
  title,
  data,
  newsId,
  commentType,
  className
}) {
  return size(data) > 0 && (
    <div className={className}>
      <div className="text-f.9">{title}</div>
      <div className="mt-pix-20">
        {
          map(data, (item) => (
            <CommentRow data={item} key={item.id} newsId={newsId} commentType={commentType} />
          ))
        }
      </div>
    </div>
  )
}
